import type { EmailSystem } from './emailTemplates'

export type EmailDispatchStatus = 'pending' | 'sent' | 'failed'

export interface EmailDispatch {
  id: string
  source_id: string
  system: EmailSystem
  template_id: number
  recipient: string
  subject_rendered: string
  variables: Record<string, unknown>
  html_storage_path: string
  status: EmailDispatchStatus
  mailgrid_status: string | null
  mailgrid_code: string | null
  mailgrid_message_id: string | null
  mailgrid_response: Record<string, unknown> | null
  error_message: string | null
  triggered_by: string | null
  created_at: string
  completed_at: string | null
  sent_storage_bucket: string
  sent_file_path: string
}

export const EMAIL_DISPATCH_STATUS_LABELS: Record<EmailDispatchStatus, string> = {
  pending: 'Pendente',
  sent: 'Enviado',
  failed: 'Falhou',
}

export const EMAIL_DISPATCH_STATUS_OPTIONS: { value: EmailDispatchStatus; label: string }[] = [
  { value: 'pending', label: EMAIL_DISPATCH_STATUS_LABELS.pending },
  { value: 'sent', label: EMAIL_DISPATCH_STATUS_LABELS.sent },
  { value: 'failed', label: EMAIL_DISPATCH_STATUS_LABELS.failed },
]
